// @ts-nocheck
import React, { lazy, Suspense, useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import "./assets/css/app.scss";
import { useNavigate } from "react-router-dom";
import Error404 from "./pages/Error404/Error404";
// import Profile from "./pages/Profile/Profile";
import Login from "./pages/login/Login";
import SsoComplete from "./pages/login/SsoComplete";
import SsoSignedOut from "./pages/login/SsoSignedOut";
import Register from "./pages/signUp/SignUp";
import "./assets/css/style.css";
import "./assets/css/styleResponsive.css";
import { ProtectedRoutesDocs } from "./utils/ProtectedRoutesDocs";
import { useSelector } from "react-redux";
import { DocBaseUrl } from "./utils/configurable";
import { mainStore } from "./Redux/store";
import ROUTES from "./docRoutes/docRoutes";
import Briefcase from "./pages/briefcase/Briefcase";
import Profile from "./pages/Profile/Profile";
import AboutSettings from "./pages/setting/aboutSetting";
import EmployeeList from "./pages/Employee/EmployeeList";
import RolePermissions from "./pages/rolePermission/RolesPermission";
import EMPLOYEEUpdateProfile from "./pages/EmployeeUpdateProfile/EmployeeUpdateProfile";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import WordEditor from "./components/wordEditor/WordEditor";

const DocGridApp = () => {
  const { userInfo } = useSelector((state) => state?.userDetails);
  const navigate = useNavigate();
  const location = useLocation();
  const val = location.pathname;

  const checkAuth = () => {
    let authForLogin = localStorage.getItem("docGridToken");
    if (authForLogin) {
      const currentPath = window.location.pathname;
      if (currentPath === ROUTES?.LOGIN) {
        navigate(ROUTES?.BRIEFCASE, { replace: true });
      }
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    document.title = "Docs Grid";
  }, []);

  useEffect(() => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon && userInfo?.thumbnailPath && userInfo?.thumbnailName) {
      favicon.href = `${DocBaseUrl}${userInfo.thumbnailPath}/${userInfo.thumbnailName}`;
    }
  }, [userInfo]);

  useEffect(() => {
    const folderArea = document.getElementById("item-class"); // 🛑 Change ID to your actual folder area ID

    const handleClickOutside = (e) => {
      if (folderArea && !folderArea.contains(e.target)) {
        sessionStorage.removeItem("unlockedFolders");
      }
    };

    const handleBeforeUnload = () => {
      sessionStorage.removeItem("unlockedFolders");
    };

    const handleRouteChange = () => {
      sessionStorage.removeItem("unlockedFolders");
    };

    window.addEventListener("click", handleClickOutside);
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("click", handleClickOutside);
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [location.pathname]);

  return (
    <>
      {/* <RootLayout> */}

      <Routes>
        <Route path="*" element={<Error404 />} />
        <Route path="/error" element={<Error404 />} />
        <Route path="/" element={<Login />} />
        <Route path={ROUTES?.LOGIN} element={<Login />} />
        <Route path={ROUTES?.SSO_COMPLETE} element={<SsoComplete />} />
        <Route path={ROUTES?.SSO_SIGNED_OUT} element={<SsoSignedOut />} />
        <Route path={ROUTES?.REGISTER} element={<Register />} />
        <Route
          path={ROUTES?.BRIEFCASE}
          element={
            <ProtectedRoutesDocs>
              <Briefcase />
            </ProtectedRoutesDocs>
          }
        />
        <Route
          path={ROUTES?.PROFILE}
          element={
            <ProtectedRoutesDocs isAccessible={ROUTES?.PROFILE}>
              <Profile />
            </ProtectedRoutesDocs>
          }
        />
        <Route
          path={ROUTES?.SETTING}
          element={
            <ProtectedRoutesDocs isAccessible={ROUTES?.SETTING}>
              <AboutSettings />
            </ProtectedRoutesDocs>
          }
        />
        <Route
          path={ROUTES?.EMPLOYEE}
          element={
            <ProtectedRoutesDocs isAccessible={ROUTES?.EMPLOYEE}>
              <EmployeeList />
            </ProtectedRoutesDocs>
          }
        />
        <Route
          path={ROUTES?.ROLEPERMISSIONS}
          element={
            <ProtectedRoutesDocs isAccessible={ROUTES?.ROLEPERMISSIONS}>
              <RolePermissions />
            </ProtectedRoutesDocs>
          }
        />
        <Route
          path={ROUTES?.EMP_PROFILE}
          element={
            <ProtectedRoutesDocs isAccessible={ROUTES?.EMP_PROFILE}>
              <EMPLOYEEUpdateProfile />
            </ProtectedRoutesDocs>
          }
        />

        <Route
          path={"/editor"}
          element={
            <ProtectedRoutesDocs>
              <WordEditor />
            </ProtectedRoutesDocs>
          }
        />
      </Routes>
      <ToastContainer position="top-center" className="p-0" style={{ pointerEvents: "none" }} autoClose={1500} />
      {/* </RootLayout> */}
      <Suspense fallback={<div></div>}></Suspense>
    </>
  );
};
export default DocGridApp;
